import React from "react";

const COMPANY_NAME = "Neurosynx LTDA";
const SYSTEM_NAME = "GridProfile";
const SYSTEM_VERSION = process.env.REACT_APP_VERSION || "0.1.0";
const COPYRIGHT_YEAR = new Date().getFullYear();

const SystemFooter = () => {
  return (
    <footer className="system-footer brand-sidebar no-print mt-auto border-t border-white/10 shadow-[0_-12px_32px_rgba(11,18,32,0.18)]">
      <div className="mx-auto flex min-h-[56px] max-w-screen-2xl items-center justify-center px-4 py-3 text-center text-xs md:text-sm">
        <span className="text-white/70">
          &copy; {COPYRIGHT_YEAR} {COMPANY_NAME}
          <span className="mx-2 text-white/25">{"\u2014"}</span>
          <span className="font-semibold text-[#00D4CB]">v{SYSTEM_VERSION}</span>
          <span className="mx-2 text-white/25">{"\u2014"}</span>
          <span className="font-medium text-white/85">{SYSTEM_NAME}</span>
        </span>
      </div>
    </footer>
  );
};

export default SystemFooter;
